import { render, staticRenderFns } from "./ConfigInfo.vue?vue&type=template&id=8ab9c86a&functional=true"
import script from "./ConfigInfo.vue?vue&type=script&lang=js"
export * from "./ConfigInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports